import { render, staticRenderFns } from "./PlanCuve.vue?vue&type=template&id=2c8d8969&"
import script from "./PlanCuve.vue?vue&type=script&lang=js&"
export * from "./PlanCuve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports